var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_801",
    "data-name": "Group 801",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_960",
    "data-name": "Rectangle 960",
    width: 40,
    height: 30,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_800",
    "data-name": "Group 800",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M34.839,0H5.161A5.19,5.19,0,0,0,0,5.217V24.783A5.19,5.19,0,0,0,5.161,30H34.839A5.19,5.19,0,0,0,40,24.783V5.217A5.19,5.19,0,0,0,34.839,0",
    fill: "#e664a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M6.141,4.951v18.5a1.6,1.6,0,0,0,1.59,1.59H18.809c8.375,0,11.979-4.665,11.979-10.866S27.184,3.308,18.809,3.308H7.784A1.725,1.725,0,0,0,6.141,4.951",
    transform: "translate(1.535 0.827)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M12.078,7.2V20.873h5.936c5.406,0,7.739-3.074,7.739-7.368,0-4.134-2.332-7.315-7.739-7.315H13.085A.975.975,0,0,0,12.078,7.2",
    transform: "translate(3.02 1.547)",
    fill: "#c06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M18.5,23.3H8.908a1.54,1.54,0,0,1-1.537-1.538V6.075A1.539,1.539,0,0,1,8.908,4.537H18.5c9.116,0,10.5,5.884,10.5,9.381,0,6.042-3.71,9.383-10.5,9.383M8.908,5.067A1.007,1.007,0,0,0,7.9,6.075V21.763a1.007,1.007,0,0,0,1.008,1.007H18.5c6.414,0,9.965-3.181,9.965-8.9,0-7.686-6.255-8.851-9.965-8.851Z",
    transform: "translate(1.843 1.134)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M14.06,10.568a1.884,1.884,0,0,1,.584.106,1.245,1.245,0,0,1,.476.318l.319.477a2.7,2.7,0,0,1,.106.689,1.99,1.99,0,0,1-.106.636,1.673,1.673,0,0,1-.265.53,1.159,1.159,0,0,1-.477.371,1.24,1.24,0,0,1-.636.106H12.629V10.516Zm-.052,2.65a.673.673,0,0,0,.317-.053c.106-.054.16-.106.265-.16.054-.105.16-.159.16-.318a1.189,1.189,0,0,0,.052-.477,1.042,1.042,0,0,0-.052-.424,1.729,1.729,0,0,0-.16-.318.523.523,0,0,0-.265-.212A1.039,1.039,0,0,0,13.9,11.2h-.53v2.066Z",
    transform: "translate(3.157 2.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M17.792,10.569v.584H16.043v.741h1.59v.53h-1.59v.795h1.749V13.8H15.3V10.516Z",
    transform: "translate(3.825 2.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M19.647,10.559l1.219,3.286h-.743l-.265-.743H18.639l-.265.743h-.743l1.22-3.286Zm.052,2.014-.424-1.219-.424,1.219Z",
    transform: "translate(4.408 2.64)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M21.3,10.568v2.65h1.59V13.8H20.558V10.516a3.8,3.8,0,0,0,.743.052",
    transform: "translate(5.14 2.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M10.212,13.654A1.484,1.484,0,1,0,8.728,12.17a1.484,1.484,0,0,0,1.484,1.484",
    transform: "translate(2.182 2.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M11.3,18.986a2.262,2.262,0,0,1-2.279-2.279v-1.8a1.166,1.166,0,1,1,2.331,0Z",
    transform: "translate(2.256 3.435)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeal);
export default __webpack_public_path__ + "static/media/ideal.51b57dfc0fbbf98baa626b2840acd885.svg";
export { ForwardRef as ReactComponent };